<template>
  <div class="select-wrap">
    <template v-if="!isLineApp">
      <SelectGroup
        class="row-item mb15"
        pointClass="j-select-server"
        selectClass="j-select-server-ele"
        v-model="serverId"
        @change="loadRole"
      >
        <template slot="option">
          <option value="0" disabled>
            {{ letter.creatework_serverHolder }}
          </option>
          <optgroup :label="letter.yourServer">
            <option
              v-for="item in historyServerList"
              :key="item.ID"
              :value="item.ID"
            >
              {{ item.NAME }}
            </option>
          </optgroup>
          <optgroup :label="letter.allServer">
            <option v-for="item in serverList" :key="item.ID" :value="item.ID">
              {{ item.NAME }}
            </option>
          </optgroup>
        </template>
        <template slot="ico">
          <em class="ico"></em>
        </template>
      </SelectGroup>
      <Select
        v-if="roleList && roleList.length !== 0"
        class="row-item role-select mb15"
        pointClass="j-select-role"
        selectClass="j-select-role-ele"
        v-model="roleId"
      >
        <template slot="option">
          <option value="-1" disabled>
            {{ letter.selectRoleName }}
          </option>
          <option
            v-for="item in roleList"
            :key="item.roleID"
            :value="item.roleID"
          >
            {{ item.roleName }}
          </option>
        </template>
        <template slot="ico">
          <em class="ico"></em>
        </template>
      </Select>
      <Select
        v-else
        class="row-item mb15"
        v-model="roleId"
        pointClass="j-select-role"
        selectClass="j-select-role-ele"
      >
        <template slot="option">
          <option value="-1" disabled v-if="!serverId">
            {{ letter.selectRoleName }}
          </option>
          <option value="-1" disabled v-else>
            {{ letter.creatework_noRole }}
          </option>
        </template>
        <template slot="ico">
          <em class="ico"></em>
        </template>
      </Select>
    </template>
    <template v-else>
      <div
        class="row-item line-picker mb15 j-select-server"
        @click="openServerPicker"
      >
        <span class="line-picker-text">{{ serverDisplayText }}</span>
        <em class="ico"></em>
      </div>
      <div
        class="row-item line-picker mb15 j-select-role"
        :class="{ 'line-picker--disabled': !canOpenRolePicker }"
        @click="openRolePicker"
      >
        <span class="line-picker-text">{{ roleDisplayText }}</span>
        <em class="ico"></em>
      </div>
      <SelectContianer
        v-if="showServerPicker"
        class="role-line-selector"
        :showChildSelect="showServerPicker"
        :isShowClose="true"
        @closeSelectContainer="closeServerPicker"
      >
        <template slot="select-header">
          {{ letter.creatework_serverHolder }}
        </template>
        <template slot="select-content">
          <ul class="role-line-select-list">
            <template v-if="historyServerList && historyServerList.length">
              <li class="role-line-select-group">{{ letter.yourServer }}</li>
              <li
                v-for="item in historyServerList"
                :key="'history-' + item.ID"
                class="select-items-popup j-select-server-ele"
                :class="{ active: item.ID == serverId }"
                @click="handleSelectServer(item)"
              >
                {{ item.NAME }}
              </li>
            </template>
            <template v-if="serverList && serverList.length">
              <li class="role-line-select-group">{{ letter.allServer }}</li>
              <li
                v-for="item in serverList"
                :key="'all-' + item.ID"
                class="select-items-popup j-select-server-ele"
                :class="{ active: item.ID == serverId }"
                @click="handleSelectServer(item)"
              >
                {{ item.NAME }}
              </li>
            </template>
          </ul>
        </template>
      </SelectContianer>
      <SelectContianer
        v-if="showRolePicker"
        class="role-line-selector"
        :showChildSelect="showRolePicker"
        :isShowClose="true"
        @closeSelectContainer="closeRolePicker"
      >
        <template slot="select-header">
          {{ letter.selectRoleName }}
        </template>
        <template slot="select-content">
          <ul class="role-line-select-list">
            <li
              v-for="item in roleList"
              :key="item.roleID"
              class="select-items-popup j-select-role-ele"
              :class="{ active: item.roleID == roleId }"
              @click="handleSelectRole(item)"
            >
              {{ item.roleName }}
            </li>
          </ul>
        </template>
      </SelectContianer>
    </template>
    <div
      class="select-role-btn"
      :class="[
        `${isPopup ? 'j-select-role-confirm-popup' : 'j-select-role-confirm'}`
      ]"
      @click="handleLoadProduct"
    >
      {{ letter.popupConfirm }}
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import coupon from '@mixins/officialTopupNew/coupon';
import login from '@mixins/officialTopupNew/login';
import SelectContianer from '@components/officialTopupNew/SelectContianer';
import { isLineApp } from '@utiles/officialStore/device';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV35';
export default {
  mixins: [login, coupon],
  components: { SelectContianer },
  props: {
    isPopup: {
      default: false
    }
  },
  data() {
    return {
      select: '',
      ico: '',
      isLineApp: isLineApp(),
      showServerPicker: false,
      showRolePicker: false
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      pcServerId: state => state.pcServerId,
      roleName: state => state.roleName,
      uid: state => state.login.uid,
      serverList: state => state.serverList,
      historyServerList: state => state.historyServerList,
      roleList: state => state.roleList
    }),
    canOpenRolePicker() {
      return !!this.serverId && this.roleList && this.roleList.length > 0;
    },
    serverDisplayText() {
      if (!this.serverId) {
        return this.letter.creatework_serverHolder;
      }
      return (
        this.getServerNameById(this.serverId) ||
        this.letter.creatework_serverHolder
      );
    },
    roleDisplayText() {
      if (!this.serverId) {
        return this.letter.selectRoleName;
      }
      if (!this.roleList || this.roleList.length === 0) {
        return this.letter.creatework_noRole;
      }
      if (!this.roleId || this.roleId === -1) {
        return this.letter.selectRoleName;
      }
      return (
        this.roleName ||
        this.getCurRoleName(this.roleId) ||
        this.letter.selectRoleName
      );
    }
  },
  methods: {
    getServerNameById(id) {
      const lists = [this.historyServerList, this.serverList];
      for (const list of lists) {
        if (!list) continue;
        for (const item of list) {
          if (item.ID == id) {
            return item.NAME;
          }
        }
      }
      return '';
    },
    openServerPicker() {
      this.showServerPicker = true;
    },
    closeServerPicker() {
      this.showServerPicker = false;
    },
    handleSelectServer(item) {
      this.serverId = item.ID;
      this.loadRole();
      this.closeServerPicker();
    },
    openRolePicker() {
      if (!this.canOpenRolePicker) {
        return;
      }
      this.showRolePicker = true;
    },
    closeRolePicker() {
      this.showRolePicker = false;
    },
    handleSelectRole(item) {
      this.roleId = item.roleID;
      this.closeRolePicker();
    },
    handleLoadProduct() {
      clickButton({
        btnName: 'bind_role_confirm',
        locationKey: locationType.charPopup
      });
      this.loadProduct('select_bind');
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.select-wrap {
  box-sizing: border-box;
}
.row-item {
  display: block;
  position: relative;
  box-sizing: border-box;
  margin: 0 auto 20px;
  width: 602px;
  height: 80px;
  background-size: cover;
  vertical-align: top;
  font-size: 24px;
  color: #333;
  border: 1px solid #e8e8e8;
  background-color: #ffffff;
  border-radius: 6px;
  ::v-deep .select {
    color: #333;
  }
  ::v-deep .ico {
    display: inline-block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: url($commonImg + 'role-ico.png') no-repeat;
    width: 22px;
    height: 13px;
  }
}

.line-picker {
  display: flex;
  align-items: center;
  padding: 0 20px;
  cursor: pointer;
  &--disabled {
    cursor: default;
    color: #999;
  }
  .line-picker-text {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ico {
    right: 20px;
  }
}

.role-line-selector {
  z-index: 1002;
  ::v-deep .select-wrapper {
    bottom: 0;
  }
}

.role-line-select-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.role-line-select-group {
  margin: 10px 0;
  font-size: 22px;
  color: #999;
}

.select-role-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px auto 0;
  line-height: 80px;
  height: 80px;
  font-size: 24px;
  color: #fff;
  font-weight: bold;
  background: $themeColor;
  border-radius: 9px;
  cursor: pointer;
}
</style>
